import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FileUpload } from '../file-upload/file-upload';
import { FIELD_TYPES } from '../../constants';
import { FormFilePreview } from './file-preview/file-preview';
const QuizFileUpload = props => {
  var _props$externalData;
  if ((_props$externalData = props.externalData) != null && _props$externalData.ownerPreview) {
    return /*#__PURE__*/React.createElement(FormFilePreview, {
      label: props.label,
      value: props.value
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FileUpload, _extends({}, props, {
    hideAsterisk: true,
    fieldType: FIELD_TYPES.QUIZ_FILE_UPLOAD
  })));
};
export default QuizFileUpload;
//# sourceMappingURL=quiz-file-upload.js.map